// Shared by the React shell and the static marketing-head build step.
// Marketing canonicals have no trailing slash except the homepage.
// Library URLs are independent and are never normalised here.
export const SITE = "https://kedbyte.com";
export const OG_IMAGE = SITE + "/og-image.png";
export const META = {
  "/": {
    title: "Custom Software Development Company in India — KedByte",
    desc: "KedByte is a software studio in Vadodara, India building custom software, applied AI and automated cloud infrastructure — from interface to production.",
  },
  "/services": {
    title: "Custom Software, AI & DevOps Automation Services — KedByte",
    desc: "Custom software development, AI & machine learning, blockchain & Web3 engineering, DevOps automation and UI/UX design — one pipeline, one partner.",
  },
  "/payroll": {
    title: "UK Payroll Software for Bureaux & Accountants — KedByte",
    desc: "In development for tax year 2026/27 — penny-exact UK payroll software for bureaux and accountants. HMRC PAYE recognition in progress. Join early access.",
  },
  "/quill": {
    title: "Quill — School Records Software in Development | KedByte",
    desc: "Quill by KedByte: school records software in development for staff working with pupil records, attendance, assessment marks and fee entries.",
  },
  "/about": {
    title: "About KedByte — Software Studio in Vadodara, Gujarat",
    desc: "Founded 2026 in Vadodara, Gujarat, KedByte Technologies Private Limited is a full-spectrum software studio pairing advanced engineering with ultra-minimal design.",
  },
  "/careers": {
    title: "Careers at KedByte — Current Openings",
    desc: "No current job or internship openings are listed at KedByte. Explore the studio and Library, or contact us with a general careers enquiry.",
  },
  "/contact": {
    title: "Contact KedByte — Start a Software Project",
    desc: "Tell us about your project — custom software, AI or automation. Contact the KedByte team in Vadodara, India.",
  },
};


export function marketingPath(pathname) {
  const path = pathname === "/" ? "/" : pathname.replace(/\/$/, "");
  return path === "/schoolos" ? "/quill" : path;
}

export function pageMeta(pathname) {
  const route = marketingPath(pathname);
  const meta = META[route] || {
    title: "KedByte — Page not found",
    desc: "This page could not be found. Explore KedByte’s services, products and Library.",
  };
  return { ...meta, canonical: SITE + route, image: OG_IMAGE };
}
